module.exports = __webpack_public_path__ + "static/Checkout-07b75d3fd946b5743ed261f682e5af4d.jpg";